(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecosystem-features"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
  $('.block_product_details .row').slick({
  slidesToShow: 3,
  dots:true,
  centerMode: true,
  autoplay:true,
  autoplaySpeed: 3000,
  responsive: [{
         breakpoint: 992,
           settings: {
             slidesToShow: 2
           }
         }, {
         breakpoint: 500,
         settings: {
           slidesToShow: 1
         }
       }]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    // Globo Menu load for mobile
    setTimeout(function(){
      jQuery('li.gm-has-submenu a .gm-text:contains("-Mobile")').closest('li').addClass('hideDesktop');
      jQuery("li.gm-has-submenu a .gm-text").text(function () {
          return $(this).text().replace("-Mobile", ""); 
      });
    },1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-animated"] && !window.DesignMode) return;
  try {
    
$('.slider').slick({
  slidesToShow: 1,
  dots:false,
  centerMode: false,
  autoplay:true,
  autoplaySpeed: 3000,
  infinite:true,
  arrows:false,
  speed: 500,
  fade: false,
  pauseOnHover:false,
  cssEase: 'linear'
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["issa-features"] && !window.DesignMode) return;
  try {
    
$('.issa-features .row').slick({
  slidesToShow: 3,
  dots:true,
  centerMode: true,
  autoplay:true,
  arrow:false,
  autoplaySpeed: 3000,
  responsive: [{
         breakpoint: 992,
           settings: {
             slidesToShow: 2,
              dots:true,
              arrow:false,
           }
         }, {
         breakpoint: 500,
         settings: {
           slidesToShow: 1,
            dots:true,
            arrow:false,
         }
       }]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !window.DesignMode) return;
  try {
    
$(document).ready(function($){

   $('.logo-bar.carousel').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
        responsive: [{
             breakpoint: 992,
               settings: {
                 slidesToShow: 2
               }
             }, {
             breakpoint: 768,
             settings: {
               slidesToShow: 1
             }
           }]
   });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naboso-simple-scroller"] && !window.DesignMode) return;
  try {
    
$(document).ready(function($){

   $('.logo-bar.carousel').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
        responsive: [{
             breakpoint: 992,
               settings: {
                 slidesToShow: 2
               }
             }, {
             breakpoint: 768,
             settings: {
               slidesToShow: 1
             }
           }]
   });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onscroll-image-slider"] && !window.DesignMode) return;
  try {
    
 
const interleaveOffset = 0.75;

var swiper = new Swiper(".swiper-container", {
  direction: "vertical",
  speed: 800,
  mousewheelControl: true,
  watchSlidesProgress: true,
  mousewheel: {
    releaseOnEdges: true
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: false,
    type: "bullets",
    renderBullet: function (index, className) {
      return (
        '<span class="' + className + '">' + ("0" + (index + 1)) + "</span>"
      );
    }
  },
  on: {
    progress: function () {
     
      let swiper = this;

      for (let i = 0; i < swiper.slides.length; i++) {
        let slideProgress = swiper.slides[i].progress;
        let innerOffset = swiper.height * interleaveOffset;
        let innerTranslate = slideProgress * innerOffset;

        TweenMax.set(swiper.slides[i].querySelector(".slide-inner"), {
          y: innerTranslate
        });
      }
    },
    setTransition: function (slider, speed) {
      let swiper = this;
      for (let i = 0; i < swiper.slides.length; i++) {
        swiper.slides[i].style.transition = speed + "ms";
        swiper.slides[i].querySelector(".slide-inner").style.transition =
          speed + "ms";
      }
    }
  }
});
setTimeout(scrollInsideDiv, 3000);
function scrollInsideDiv(){
  $(".image-slider-wrapper .page-width").hover(function() {
  var oldScrollPos = $(window).scrollTop();
  
  $(window).on('scroll.scrolldisabler', function(event) {
    $(window).scrollTop(oldScrollPos);
    event.preventDefault();
  });
  }, function() {
  $(window).off('scroll.scrolldisabler');
  });
}

// slick slider
const $slider = $("#vertical-slider");
//$slider
	// .on("init", () => {
	// 	mouseWheel($slider);
	// })
if ($slider.length) {  
  var currentSlide;
  var slidesCount;
  
  var updateSliderCounter = function(slick, currentIndex) {
    currentSlide = slick.slickCurrentSlide() + 1;
    slidesCount = slick.slideCount;
  };
  
  $slider.on('init', function(event, slick) {
    updateSliderCounter(slick);
  });
  
  $slider.on('afterChange', function(event, slick, currentSlide) {
    updateSliderCounter(slick, currentSlide);
  });
  
  $slider.slick({
      dots: false,
      vertical: true,
      infinite: false,
      prevArrow: false,
      nextArrow: false
  });
  $slider.on('wheel', (function(e) {
  	e.preventDefault();
      // currentSlide = slick.slickCurrentSlide() + 1;
      // slidesCount = slick.slideCount;
  	if (e.originalEvent.deltaY < 0) {
  		$(this).slick('slickPrev');
  		behavior: 'smooth';
  		if(currentSlide==1){
  			window.scroll({ top: window.scrollY - 482, behavior: 'smooth' });
  		}
  	} else {
  		$(this).slick('slickNext');
  		behavior: 'smooth';
  		if(slidesCount==currentSlide){
  			window.scroll({ top: window.scrollY + 482 , behavior: 'smooth' });
  		}
  	}
  }));
}
// function mouseWheel($slider) {
// 	$(window).on("wheel", { $slider: $slider }, mouseWheelHandler);
// }
// function mouseWheelHandler(event) {
// 	event.preventDefault();
// 	const $slider = event.data.$slider;
// 	const delta = event.originalEvent.deltaY;
// 	if (delta > 0) {
// 		$slider.slick("slickNext");
// 	} else {
// 		$slider.slick("slickPrev");
// 	}
// }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plantar-banner"] && !window.DesignMode) return;
  try {
    
jQuery(document).ready(function(){
  jQuery('.plantar-banner-slider').slick({
    slidesToShow: 1,
    dots:false,
    centerMode: false,
    autoplay:true,
    autoplaySpeed: 2000,
    arrows: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plantar-features"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
  $('.block_product_details .row').slick({
  slidesToShow: 3,
  dots:false,
  centerMode: true,
  autoplay:true,
  autoplaySpeed: 3000,
  responsive: [{
         breakpoint: 992,
           settings: {
             dots:false,
             slidesToShow: 2
           }
         }, {
         breakpoint: 500,
         settings: {
           dots:false,
           slidesToShow: 1
         }
       }]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recovery-testimonials"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
  $('.carousel').slick({
  slidesToShow: 3,
  dots:true,
  centerMode: true,
  autoplay:true,
  autoplaySpeed: 3000,
  responsive: [{
         breakpoint: 992,
           settings: {
             slidesToShow: 2
           }
         }, {
         breakpoint: 768,
         settings: {
           slidesToShow: 1
         }
       }]
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-compare-products"] && !window.DesignMode) return;
  try {
    
  jQuery('#showMore').click(function() {
    jQuery('#showMore').hide();
    jQuery('#showLess').show();
    jQuery('.uses').removeClass('hideMobile');
  });
  jQuery('#showLess').click(function() {
    jQuery('#showMore').show();
    jQuery('#showLess').hide();
    jQuery('.uses').addClass('hideMobile');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studiosocks-features"] && !window.DesignMode) return;
  try {
    
jQuery(document).ready(function(){
  jQuery('.studiosocks-features .row').slick({
  slidesToShow: 3,
  dots:true,
  centerMode: true,
  autoplay:true,
  autoplaySpeed: 3000,
  responsive: [{
         breakpoint: 993,
           settings: {
             slidesToShow: 2,
             dots:true
           }
         }, 
         {
         breakpoint: 500,
         settings: {
           slidesToShow: 1,
           dots:true
         }
       }]
  });
});

  } catch(e) { console.error(e); }
})();
})();
